import {IListRecipe} from '../../../../core/model/recipe/list-recipe.model';
import {Component, Input} from '@angular/core';
import {Recipe} from '../../../../core/model/recipe/recipe.model';
import {patchRecipeDone} from '../../../../core/store/recipe/recipe.actions';
import {ModalService} from '../../../services/util/modal.service';
import {WishService} from '../../../services/wish.service';
import {Store} from '@ngrx/store';
import {AppState} from '../../../../core/store/app.state';
import {AnnotationRecipeUtils} from '../annotation-recipe.utils';
import {User} from '../../../../core/model/user/user.model';
import {StateStorageService} from '../../../services/auth/state-storage.service';
import {Router} from '@angular/router';


@Component({
    selector: 'app-recipe-card-component',
    templateUrl: './recipe-card.component.html',
    styleUrls: ['./recipe-card.component.scss'],
    standalone: false
})
export class RecipeCardComponent {

  @Input() currentRecipes: IListRecipe[];
  @Input() currentUser: User;

  constructor(
    protected modalService: ModalService,
    protected wishService: WishService,
    protected router: Router,
    private stateStorageService: StateStorageService,
    protected store: Store<AppState>
  ) {
  }

  closeModalLogin(id: string): void {
    this.closeModal(id);
    this.stateStorageService.storeUrl(this.router.url);
  }

  addWish(recipe: IListRecipe, event: Event): void {
    event.stopPropagation();
    event.stopImmediatePropagation();
    event.preventDefault();

    if (!this.currentUser) {
      this.openModal('add-wish');
      return;
    }

    if (recipe.wish) {
      this.wishService.addWish(recipe.id).subscribe({
        next: () => {
          const newRecipe: Recipe = JSON.parse(JSON.stringify(recipe));
          newRecipe.wish = false;
          try {
            recipe.wish = false;
          } catch (error) {
          }
          this.store.dispatch(patchRecipeDone({recipe: newRecipe}));
        },
        error: (err) => {
          console.error(err);
        }
      });

    } else {
      this.wishService.removeWish(recipe.id).subscribe({
        next: () => {
          const newRecipe: Recipe = JSON.parse(JSON.stringify(recipe));
          newRecipe.wish = true;
          try {
            recipe.wish = true;
          } catch (error) {
          }
          this.store.dispatch(patchRecipeDone({recipe: newRecipe}));
        },
        error: (err) => {
          console.error(err);
        }
      });
    }
  }

  getTime(minutes: number): string {
    return AnnotationRecipeUtils.getTime(minutes);
  }

  openModal(id: string): void {
    this.modalService.open(id);
  }

  closeModal(id: string): void {
    this.modalService.close(id);
  }


}
